import { IAmusnetServerGame, IAmusnetGetUrl } from '../../types/interfaces/Slots/Amusnet';
import { IConvertGameList, ISlotConverter } from '../../types/converter';
import { getTab, liveCasinoGames } from './utils';
import { ISlotViewItem } from '../../types/interfaces/Slots/Slots';
import { CasinoType } from 'modules/Casino/types/configuration';

class Converter implements ISlotConverter {
  convertGameList = ({ data }: IConvertGameList<IAmusnetServerGame[]>): ISlotViewItem[] => {
    const games = data
      .filter(game => liveCasinoGames.includes(game.id.toString()))
      .map((game: IAmusnetServerGame) => ({
        id: game.id.toString(),
        gameId: game.id.toString(),
        description: game.title,
        gameName: game.title,
        provider: 'amusnet',
        type: CasinoType.liveCasino,
        routeProvider: 'amusnet',
        tab: getTab(game.id.toString()),
        imageUrl: game.details.thumbnails['300x300'],
      }));
    return games;
  };

  convertGameUrl = ({ data }: IAmusnetGetUrl) => data.url;
}
export default Converter;
